import axios from "axios";

import { DSR_ACCESS_TOKEN } from "@/store/constants/global";
import { getToken, logout as auth0Logout } from "@/services/AuthService";

const BASE_URL = process.env.VUE_APP_BASE_URL_API;
const URL_LOGOUT = process.env.VUE_APP_LOGOUT_URL;

const baseAxios = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

// Add a request interceptor
baseAxios.interceptors.request.use(
  async function (config) {
    // Auth0の設定が存在するか確認
    const hasAuth0Config =
      process.env.VUE_APP_AUTH0_DOMAIN && process.env.VUE_APP_AUTH0_CLIENT_ID;

    let token;

    // 契約社員のトークンを最初にチェック
    const contractorToken = localStorage.getItem('contractor_token');
    if (contractorToken) {
      token = contractorToken;
    } else if (hasAuth0Config) {
      // Auth0が設定されている場合はlocalStorageからIDトークンを取得
      token = localStorage.getItem(DSR_ACCESS_TOKEN);

      // localStorageにトークンがない場合はAuth0から取得
      if (!token) {
        token = await getToken();
      }
    }

    // Do something before request is sent
    if (token && !isUploadImagePath(config.url)) {
      config.headers["Authorization"] = `Bearer ${token}`;
      // 後方互換性のために従来のトークンヘッダーも維持
      config.headers["token"] = token;
    }
    return config;
  },
  function (error) {
    console.error(error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
baseAxios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.error('BaseApi response error:', error);
    if (error.response && error.response.status === 401) {
      console.log('401 error detected, calling logout()');
      logout();
    }

    return Promise.reject(error);
  }
);

const logout = () => {
  // 契約社員トークンが存在する場合は、契約社員専用のログアウト処理
  const contractorToken = localStorage.getItem('contractor_token');
  
  console.log('logout() called, contractorToken:', !!contractorToken);
  
  if (contractorToken) {
    console.log('Contractor logout: clearing token and redirecting');
    // 契約社員のトークンをクリア
    localStorage.removeItem('contractor_token');
    
    // 契約社員ログイン画面にリダイレクト
    window.location.href = '/contractor/signin';
    return;
  }
  
  console.log('Auth0 logout: calling auth0Logout()');
  // Auth0ログアウトを呼び出し
  auth0Logout();

  // localStorageからトークンを削除
  localStorage.removeItem("DSR_ACCESS_TOKEN");

  // 従来のログアウト処理もバックアップとして実行
  if (URL_LOGOUT) {
    document.cookie = "token=code=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    window.location.replace(URL_LOGOUT);
  }
};

const isUploadImagePath = (url) => {
  // 新しいエンドポイント（/diaries/image/purl/）には認証トークンを付与する
  // 古いエンドポイント（/diaries/image/）のみトークンを付与しない
  return (
    url.includes("/diaries/image/") && !url.includes("/diaries/image/purl/")
  );
};

export default baseAxios;
export const baseUrl = BASE_URL;
